import { push } from "connected-react-router";
import nProgress from "nprogress";
import { all, apply, put, takeEvery } from "redux-saga/effects";
import { USER_ACTIVATE_AUTO_LOGIN } from "~/actions/activate";
import { UserInvitationSucceedAction, USER_INVITATION_SUCCEED } from "~/actions/invitation";
import { raiseRedirectExternal } from "~/actions/redirectExternal";
import authProvider from "~/authProvider/authProvider";
import { ssoApiClient } from "~/lib/client";
import { CallReturnType } from "~/utils/sagaTypsHelper";
import { handleAutoLogin } from "./activate";


export function handleUserInvitation(autoLogin: ReturnType<typeof handleAutoLogin>) {
  return function* (action: UserInvitationSucceedAction) {
    const { payload } = action

    if (payload.isSsoEnabled) {
      nProgress.start()
      
      try
      {
        const { data: url }: CallReturnType<typeof ssoApiClient.apiSsoRedirecturlPost> = 
          yield apply(ssoApiClient, 'apiSsoRedirecturlPost', [{ email: payload.username }])
        
        yield put(raiseRedirectExternal(url))
        
        nProgress.done()
      }
      catch (err) {
        yield put(push('/login'))
        nProgress.done()
      }

    } else {
      yield autoLogin({
        type: USER_ACTIVATE_AUTO_LOGIN,
        payload: {
          ...payload, 
          method: 'InvitationActivate',
        },
      })
    }
  }
}

export default function* invitationSaga() {
  yield all([
    takeEvery(USER_INVITATION_SUCCEED, 
      handleUserInvitation(
        handleAutoLogin(authProvider))),
  ])
}

